<template>
    <div class="personal-education-components">
        <!-- 筛选 -->
        <form
            ref="form"
            @submit.prevent="fetchData"
            class="pb-6 flex justify-between personal-form">
            <div class="flex">
                <el-select
                    class="pr-2"
                    v-model="form.storeId"
                    placeholder="$t('Common.store_placeholder')">
                    <el-option
                        v-for="(item, index) in stores"
                        :key="`${index}-${item.id}`"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select
                    class="pr-2"
                    v-model="form.coachId"
                    :placeholder="$t('Common.choose_coach')">
                    <input
                        class="croup-coach"
                        type="text"
                        v-model="searchText" >
                    <el-option
                        v-for="item in filterList"
                        :key="item.id"
                        :label="item.nickname"
                        :value="item.id"
                        :disabled="item.id == 'no'">
                    </el-option>
                </el-select>
                <el-select
                    class="pr-2"
                    v-model="form.status"
                    :placeholder="$t('Reception.Second.appoint_status')">
                    <el-option
                        v-for="(item, index) in status"
                        :key="`${index}-${item.code}`"
                        :label="item.name"
                        :value="Number(item.code)">
                    </el-option>
                </el-select>
                <el-select
                    class="pr-2"
                    v-model="form.lessonType"
                    :placeholder="$t('Choose.type')">
                    <el-option
                        v-for="(item, index) in types"
                        :key="`${index}-${item.code}`"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
            </div>
            <div class="flex items-center">
                <div class="flex items-center">
                    <span class="label">{{ $t('Lesson.time') }}:</span>
                    <el-date-picker
                        width="w/6"
                        class="mr-1"
                        v-model="date"
                        type="datetimerange"
                        :start-placeholder="$t('Common.start_time')"
                        :end-placeholder="$t('Common.end_time')"
                        :default-time="['00:00:00', '23:59:59']"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </div>
                <el-input
                    class="personal-search"
                    type="text"
                    v-model="form.keyword"
                    :placeholder="$t('Member.search')"></el-input>
                <div class="pl-2">
                    <el-button
                        type="primary"
                        native-type="submit"
                    >{{ $t('Common.search') }}</el-button>
                </div>
                <div class="pl-2">
                    <el-button @click="handleReset">{{ $t('Common.clear') }}</el-button>
                </div>
            </div>
        </form>
        <div class="personal-handle-tab flex justify-end">
            <el-tooltip effect="dark" :content="$t('Lesson.dai')" placement="bottom">
                <div
                    @click="handleCreate"
                    class="iconfont icon-fitness-tianjiawenjian"></div>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('Lesson.edit_coach')" placement="bottom">
                <div @click="handleEdit"
                    class="iconfont icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy">
                </div>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('Lesson.sign')" placement="bottom">
                <div
                    class="iconfont add icon-fitness-qiandao"
                    @click="handleSignin"></div>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('Lesson.canale_appoint')" placement="bottom">
                <div
                    class="iconfont edit icon-fitness-iconsvggyiquxiao"
                    @click="handleCancel"></div>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('Lesson.small_print')" placement="bottom">
                <div
                    class="iconfont delete icon-fitness-dayin"
                    @click="handlePrint"></div>
            </el-tooltip>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%;margin: 15px 0;"
            ref="singleTable"
            highlight-current-row
            @current-change="handleCurrentChange"
            border>
            <el-table-column prop="storeName" :label="$t('Lesson.store')" />
            <el-table-column width="100" :label="$t('Lesson.time')">
                <template slot-scope="{row}">
                    {{ row.lessonDate }}<br>{{ row.lessonTime }}
                </template>
            </el-table-column>
            <el-table-column prop="followCoachNickname" :label="$t('Common.follow_coach')" />
            <el-table-column prop="status" :label="$t('Course.appoint_status')" />
            <el-table-column prop="actualCoachNickname" :label="$t('Course.true_caoch')" />
            <el-table-column :label="$t('Member.name')">
                <template slot-scope="{row}">
                    <div
                        @click="handleUser(row.clientId)"
                        class="personal-education-blue cursor-pointer">
                        {{ row.clientName }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="clientPhone" :label="$t('Common.phone_number')" />
            <el-table-column prop="lessonName" :label="$t('Course.name2')" />
            <el-table-column prop="lessonType" :label="$t('Course.course_type')" />
            <el-table-column :label="$t('Common.use_con')" >
                <template slot-scope="{row}">
                    <div
                        @click="godetails(row)"
                        class="personal-education-blue cursor-pointer">
                        {{ row.contractName }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="lessonCount" :label="$t('Course.class_number')" />
            <el-table-column prop="lessonBalance" :label="$t('Course.Make_an_appointment')" />
            <el-table-column prop="singlePrice" :label="$t('Course.Single_class_value')" />
            <el-table-column :label="$t('Reception.Second.appoint_time')">
                <template slot-scope="{row}">
                    {{ row.reservedDate }}<br>{{ row.reservedTime }}
                </template>
            </el-table-column>
            <el-table-column prop="reservedName" :label="$t('Course.Appointments')" />
            <el-table-column :label="$t('Course.sign_time')">
                <template slot-scope="{row}">
                    {{ row.signedDate }}<br>{{ row.signedTime }}
                </template>
            </el-table-column>
            <el-table-column prop="signedName" :label="$t('Course.sign_person')" />
            <el-table-column :label="$t('Course.Recent_admission')">
                <template slot-scope="{row}">
                    {{ row.lastEnterDate }}<br>{{ row.lastEnterTime }}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableData && tableData.length"
            class="text-right"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>

        <!--弹窗-->
        <add-coach-reserve @fetchData="fetchData" ref="addCoachReserve"/>
        <edit-coach-reserve ref="editCoachReserve" @fetchData="fetchData" />
        <sign-coach-schedule ref="signCoachSchedule"  @fetchData="fetchData" />
    </div>
</template>

<script>
import { Tabs, TabPane, DatePicker, Radio } from 'element-ui';
import addCoachReserve from '@/components/Dialog/Course/addCoachReserve';
import editCoachReserve from '@/components/Dialog/Course/editCoachReserve';
import signCoachSchedule from "@/components/Dialog/Course/signCoachSchedule";
import handleUser from '@/mixins/handleUser.js';
import filterRole from '@/mixins/filterRole.js';

export default {
    components: {
        ElTabs: Tabs,
        ElRadio: Radio,
        ElTabPane: TabPane,
        ElDatePicker: DatePicker,
        addCoachReserve,
        editCoachReserve,
        signCoachSchedule,
    },
    mixins: [filterRole, handleUser],
    props: ['activeName'],
    data() {
        return {
            tableData: [],
            form: {
                coachId: Number(this.$route.query.coachId) || null,
                storeId: null,
                status: 0,
                lessonType: null,
                page: 1,
                keyword: '',
                lessonTimeFrom: this.$route.query.lessonBeginAt || null,
                lessonTimeTo: this.$route.query.lessonEndAt || null,
            },
            coachs: [],
            stores: [],
            searchText: '',
            status: [],
            types: [],
            date: [],
            // 页数
            pagination: {
                total: 0,
                size: 10,
            },
            currentRow: null,
            storeId: this.$route.query.storeId,
        };
    },
    created() {
        if (this.activeName === 'third') {
            this.fetchCoach();
            this.fetchData();
            this.fetchStore();
            this.fetchAll();
        }
    },
    watch: {
        'activeName'(val) {
            if (val === 'third') {
                this.fetchCoach();
                this.fetchData();
                this.fetchStore();
                this.fetchAll();
            } else {
                this.storeId = null;
                this.lessonId = null;
            }
        },
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.coachs;
            const arr = this.coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        fetchTime() {
            const arr = [];
            const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            arr[0] = `${year}-${month}-01 00:00:00`;
            arr[1] = `${year}-${month}-${day} 23:59:59`;
            this.date = arr;
        },
        handleCurrentChange(val) {
            this.currentRow = val;
        },
        async fetchCoach() {
            const roleIds = [7, 8];
            const arr = await this.filterRole(null, roleIds);
            this.coachs = [];
            this.coachs.push({
                id: null,
                nickname: this.$t('Common.all_coath'),
            });
            arr.forEach(el => this.coachs.push(el));
        },
        async fetchData() {
            // 获取当前月时间
            const form = Object.assign({}, this.form);
            if ((!this.date || !this.date.length) && !form.lessonTimeFrom && !form.lessonTimeTo) {
                this.fetchTime();
            } else if (form.lessonTimeFrom && form.lessonTimeTo && (!this.date || !this.date.length)) {
                this.date = [];

                this.date.push(form.lessonTimeFrom);
                this.date.push(form.lessonTimeTo);
            } else if (form.lessonTimeFrom && form.lessonTimeTo && this.date.length) {
                form.lessonTimeFrom = this.date[0];
                form.lessonTimeTo = this.date[1];
            }

            // 仪表盘跳转
            if (this.storeId) {
                this.form.storeId = this.storeId;
            }
            if (!form.status) delete form.status;
            // 起始时间修改
            if (this.date && !form.lessonTimeFrom && !form.lessonTimeTo) {

                form.lessonTimeFrom = this.date[0];
                form.lessonTimeTo = this.date[1];
            }
            await API.get('lesson/coach/schedule/pages', {
                params: form,
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                this.$emit('handleForm', form);
            });
            // 清空仪表盘跳转数据
            this.storeId = null;
            this.lessonId = null;
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = [];
                this.stores.push({
                    id: null,
                    name: this.$t('Common.all_store2'),
                });
                res.map(el => {
                    this.stores.push(el);
                    return this.stores;
                });
            });
        },
        fetchAll() {
            API.get('constant/lesson').then(res => {
                this.status = res.reserveStatus;
                this.types = res.coachLessonType;
            });
        },
        handleReset() {
            this.form = {
                coachId: null,
                storeId: null,
                status: 0,
                lessonType: null,
                page: 1,
                keyword: '',
                lessonTimeFrom: null,
                lessonTimeTo: null,
            };
            this.fetchData();
        },
        // 代预约私教课程
        handleCreate() {
            this.$refs.addCoachReserve.open();
        },
        // 修改
        handleEdit() {
            if (!this.currentRow) return $ele.$message(this.$t('Common.choose_one'));
            console.log('currentRow', this.currentRow);
            const {status} = this.currentRow;
            const {statusCode} = this.currentRow;
            const {id} = this.currentRow;
            if (![1, 2].includes(statusCode)) {
                const msg = `您选择的记录${status}，不允许编辑！`;
                $ele.$alert(msg, this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                });
            } else if ([1, 2].includes(statusCode) && this.$$filterPermission('课程-私教预约表-临时更换教练')) {
                this.$refs.editCoachReserve.open(id);
            } else if (!this.$$filterPermission('课程-私教预约表-临时更换教练')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            }
        },
        //签到跳转
        handleSignT(){
            if (!this.currentRow) return $ele.$message(this.$t('Common.choose_one'));
            console.log('currentRow', this.currentRow);

            const {status} = this.currentRow;
            const {statusCode} = this.currentRow;

            const {id} = this.currentRow;
            if (![1, 2].includes(statusCode)) {
                const msg = `您选择的记录${status}，不允许签到！`;
                $ele.$alert(msg, this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                });
            }else {
                if (this.$$filterPermission('课程-私教预约表-私教课代签到')){
                    this.$refs.signCoachSchedule.open(id);
                }else {
                    $ele.$alert(this.$t('Alert.not_have_the_right'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: () => {},
                    });
                }

            }



        },
        // 签到
        handleSignin() {
            if (!this.currentRow) return $ele.$message(this.$t('Common.choose_one'));
            $ele.$confirm(this.$t('Course.sign_in_for_course'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.$$filterPermission('课程-私教预约表-私教课代签到')) {
                    API.put(`/lesson/coach/schedule/${this.currentRow.id}/sign`)
                        .then(() => {
                            $ele.$message.success(this.$t('Message.success_sign'));
                            this.fetchData();
                        });
                } else {
                    $ele.$alert(this.$t('Alert.not_have_the_right'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: () => {},
                    });
                }
            }).catch(() => {
                $ele.$message(this.$t('Message.canceldo'));
            });
        },
        // 取消
        handleCancel() {
            if (!this.currentRow) return $ele.$message(this.$t('Common.choose_one'));
            var statusCode = this.currentRow.statusCode;
            if ([4].includes(statusCode)) return $ele.$message('已取消,请不要重复取消~~');
            if ([3].includes(statusCode)) return $ele.$message('已签到,无法取消预约~~');
            $ele.$confirm(this.$t('Message.Determine_cancel_course'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.$$filterPermission('课程-私教预约表-私教课取消预约')) {
                    API.delete(`/lesson/coach/schedule/${this.currentRow.id}/cancel`)
                        .then(() => {
                            $ele.$message.success(this.$t('Message.cancel_success'));
                            this.fetchData();
                        });
                } else {
                    $ele.$alert(this.$t('Message.not_have_right_cancel'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: () => {},
                    });
                }
            }).catch(() => {
                $ele.$message(this.$t('Message.canceldo'));
            });
        },
        // 打印
        handlePrint() {
            if (!this.currentRow) $ele.$message(this.$t('Common.choose_one'));
            else if (!this.$$filterPermission('课程-私教预约表-私教上课小票打印')) {
                this.$router.push('/403');
            } else {
                const {id} = this.currentRow;
                const {location} = window;
                const link = `${location.origin}/admin/print?lessonId=${id}`;
                window.open(link);
            }
        },
        // 表格中跳转
        godetails(row) {
            let activeName;
            const {contractNum} = row;
            const {contractType} = row; // 0-无,2-私教合同,4-储值卡合同
            if (contractType === 2) activeName = 'personal';
            else if (contractType === 4) activeName = 'cardsCon';
            this.$router.push({
                name: 'Sell',
                query: {
                    activeName: activeName,
                    contractNum: contractNum,
                },
            });
        },
    },
};
</script>


<style lang="scss">
.personal-education-components {
    .el-date-editor--daterange.el-input__inner {
        width: 240px;
    }
}
.personal-form {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
}
.label {
    white-space: nowrap;
    font-size: 13px;
    margin-right: 15px;
}
.personal-search {
    width: 240px;
}
.personal-handle-tab {
    margin-bottom: 10px;
    color: #697a8e;

    div {
        margin: 0 6px;
    }
}
.personal-education-blue {
    color: #05abef;
}
</style>
